module.exports = __webpack_public_path__ + "static/media/blog3.1c1c583a.png";